import api from '../../services/api';

export default {
  state: {
    screenList: []
  },
  getters: {
  },
  mutations: {
    setScreenList(state, payload) {
      state.screenList = payload
    }
  },
  actions: {
    async apiGetScreenList({ commit }, payload) {
      const { screen, programId, date } = payload
      let encodedScreen = screen ? encodeURIComponent(screen) : null
      const data = await api.get(`/screens/${encodedScreen}?reference_date=${date}&program_id=${programId}`)
      commit("setScreenList", data.data)
      return data.data
    },
    async apiGetScreen(context, payload) {
      const { view, programId, params } = payload
      const encodedView = view ? encodeURIComponent(view) : null
      let query = `program_id=${encodeURIComponent(programId)}`
      Object.keys(params || {}).forEach((key) => {
        const value = params[key]
        if (value !== null && value !== undefined && value !== '') {
          query += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        }
      })
      const data = await api.get(`/screens/${encodedView}?${query}`)
      return data.data
    },
    async apiGetPlatformScreen(context, payload) {
      const { view, programId, spec, params } = payload
      const encodedView = view ? encodeURIComponent(view) : null
      let query = `program_id=${encodeURIComponent(programId)}&program_role=owner`
      if (spec) {
        query += `&spec=${encodeURIComponent(spec)}`
      }
      Object.keys(params || {}).forEach((key) => {
        const value = params[key]
        if (value !== null && value !== undefined && value !== '') {
          query += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        }
      })
      const data = await api.get(`/platform_screens/${encodedView}?${query}`)
      return data.data
    }
  }
}
